export const comparisonWorkspaceEnabled = import.meta.env.VITE_LOCAL_RESEARCH_COMPARE === 'true';

/**
 * Ob die Vergleichsadresse ihre Seite zeigt. Nur ein Entwicklerkonto sieht sie;
 * ein gewöhnliches Konto -- und eines, dessen Fähigkeiten noch nicht feststehen
 * -- wird in den Chat geschickt.
 */
export const showsComparisonRoute = (developer: boolean): boolean =>
  comparisonWorkspaceEnabled && developer;

/**
 * Das Ziel nach der Anmeldung: die Startseite, für jedes Konto gleich (UI-14, Entscheidung 18.10.2026). Ein Entwicklerkonto
 * öffnet den Vergleich über „A/B-Vergleich“; ein ausdrücklicher Tiefenverweis bleibt unangetastet.
 */
export const authenticatedLandingPath = (requestedPath?: string): string =>
  requestedPath && requestedPath !== '/' ? requestedPath : '/';
